import { render } from "./PortfolioClientsList.vue?vue&type=template&id=5f88b9dc&scoped=true"
import script from "./PortfolioClientsList.vue?vue&type=script&lang=js"
export * from "./PortfolioClientsList.vue?vue&type=script&lang=js"

import "./PortfolioClientsList.vue?vue&type=style&index=0&id=5f88b9dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f88b9dc"]])

export default __exports__